import React from 'react'
import { Form as FormikForm, Formik } from 'formik'
import Form from '@components/Common/Form'
import Modal from '@components/Common/Modal'
import Button from '@components/Common/Button'
import Select from '@components/Common/Select'
import ModalActions from '@components/Common/Modal/Actions'
import { ModalProps } from '@interfaces/Modal'
import { editAcessoUsuario } from '@modules/acesso/controllers/usuarioController'
import { useAppDispatch, useAppSelector } from '@redux/hooks'
import createSelectItems from '@utils/createSelectItems'
import { editAcessoUsuariosFormSchema } from './config'

const ModalEdit: React.FC <ModalProps> = props => {

    const dispatch = useAppDispatch()
    const { userData } = useAppSelector(s => s.auth)
    const { acessoGrupos } = useAppSelector(s => s.acessoGrupo)
    const { currentAcessoUsuario } = useAppSelector(s => s.acessoUsuario)
    const { requestUpdateUsuario } = useAppSelector(s => s.requestAcessoUsuario)

    const idGrupoAcesso = currentAcessoUsuario?.grupoAcesso?.id ? currentAcessoUsuario.grupoAcesso.id : null

    return(

        <>
            {!!currentAcessoUsuario && (
                <Modal {...props} title = "Editar usuário">
                    <Formik
                        initialValues = {{
                            id: currentAcessoUsuario.id,
                            nome: currentAcessoUsuario.nome,
                            login: currentAcessoUsuario.login,
                            nroDocumento: currentAcessoUsuario.nroDocumento,
                            dtNascimento: currentAcessoUsuario.dtNascimento,
                            senha: null,
                            idGrupoAcesso,
                            idUsuarioAlteracao: userData!.id,
                            email: currentAcessoUsuario.email,
                        }}
                        validationSchema = {editAcessoUsuariosFormSchema}
                        onSubmit = {v => editAcessoUsuario(dispatch, userData!, v, props.setOpen)}
                    >
                        {({ setFieldValue, values, errors }) => (
                            <FormikForm>
                                <Form.Container padding = {false}>
                                    <Form.Row columns = {2}>
                                        <Form.Group inputID = "nome" inputName = "nome" label = "Nome" />
                                        <Form.Group inputID = "email" inputName = "email" label = "E-mail" />
                                    </Form.Row>
                                    <Form.Row columns = {2}>
                                        <Form.Group inputID = "nroDocumento" inputName = "nroDocumento" label = "Documento"  />
                                        <Form.Group inputID = "dtNascimento" inputName = "dtNascimento" label = "Data de Nascimento" inputType = "date"  />
                                    </Form.Row>
                                    <Form.Row columns = {2}>
                                        <Form.Group inputID = "login" inputName = "login" label = "Login" />
                                        <Form.Group inputID = "senha" inputName = "senha" label = "Senha" inputType = "password" />
                                    </Form.Row>
                                    <Form.Row columns = {1}>
                                        <Select
                                            type = "outline"
                                            label = "Grupo de Acesso"
                                            fieldName = "idGrupoAcesso"
                                            value = {values.idGrupoAcesso}
                                            error = {!!errors.idGrupoAcesso}
                                            setFieldValue = {setFieldValue}
                                            items = {createSelectItems(acessoGrupos, 'nome', 'id')}
                                        />
                                    </Form.Row>
                                    <ModalActions>
                                        <Button
                                            type = "reset"
                                            label = "Cancelar"
                                            onClick = {() => props.setOpen(false)}
                                        />
                                        <Button
                                            type = "submit"
                                            label = "Salvar"
                                            loading = {requestUpdateUsuario.loading}
                                            status = "success"
                                        />
                                    </ModalActions>
                                </Form.Container>
                            </FormikForm>
                        )}
                    </Formik>
                </Modal>
            )}
        </>
        
    )

}

export default ModalEdit